import { useCallback, useMemo, useState, type ReactNode } from 'react';
import {
  FloatingActionsContext,
  type FloatingActionEntry,
} from './floatingActionsContext';

// Live registry of every block's suggested-action row for the floating bar.
export const FloatingActionsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [entries, setEntries] = useState<Map<string, FloatingActionEntry>>(
    () => new Map()
  );

  const register = useCallback((id: string, entry: FloatingActionEntry) => {
    setEntries((prev) => {
      const next = new Map(prev);
      next.set(id, entry);
      return next;
    });
  }, []);

  const unregister = useCallback((id: string) => {
    setEntries((prev) => {
      if (!prev.has(id)) return prev;
      const next = new Map(prev);
      next.delete(id);
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({ entries, register, unregister }),
    [entries, register, unregister]
  );

  return (
    <FloatingActionsContext.Provider value={value}>
      {children}
    </FloatingActionsContext.Provider>
  );
};
